import { render, staticRenderFns } from "./type-transfer.vue?vue&type=template&id=1c37ece3&"
import script from "./type-transfer.vue?vue&type=script&lang=ts&"
export * from "./type-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./type-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports